import { Component, EventEmitter, Input, Output } from '@angular/core';
import { StoreLoader, Unsubscriber } from '@core-lib/classes';
import { ActionType, LibellePartie1, LibellePartie2, TiersType } from '@core-lib/enums';
import { camelCaseToPascalCase, formatDate } from '@core-lib/functions';
import { IAction, ITiers, ITiersWithAdress } from '@core-lib/models';
import { ModalRef, ModalService } from '@core-lib/modules/modal-container';
import { TiersFormComponent } from '../tiers-form/tiers-form.component';
import { UserPermission } from '@core-lib/enums/user-permission.enum';
import { TiersService } from '@core-lib/services';
import { SharedStoreSelectors } from '@core-lib/store/shared-store';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';


@Component({
    selector: 'tiers-partie-detail',
    templateUrl: './tiers-partie-detail.component.html',
    standalone: false
})
export class TiersPartieDetailComponent extends Unsubscriber {
	
	@Input() set libelle(libelle: LibellePartie1 | LibellePartie2) {
		this._libelle = libelle;
		this.libelleKey = camelCaseToPascalCase(libelle);
	}

	@Input() tiersPartie: ITiers[];
	@Output() action: EventEmitter<IAction> = new EventEmitter();
	@Input() affaireId: string;
	@Input() structureId: string;
	@Input() fromFO: boolean;
	private _isCompteBancaireClos: boolean | null = false;

	@Input()
	set isCompteBancaireClos(value: boolean | null) {
		this._isCompteBancaireClos = value ?? false;
	}

	get isCompteBancaireClos(): boolean | null {
		return this._isCompteBancaireClos;
	}
	private _libelle: LibellePartie1 | LibellePartie2;
	libelleKey: string;
	modalRef: ModalRef;
	tiersType = TiersType;
	formatDate = formatDate;
	userPermission = UserPermission;
	closeWithUpdate = false;

	constructor(
		private modalService: ModalService, private tiersService: TiersService, private store$: Store<any>
	) {
		super();
	}

	setNomEmetteurFromTiers(tiers?: ITiers): string {
		if (tiers.type === TiersType.PersonnePhysique) {
			let nom = tiers.nom ? tiers.nom : '';
			let prenom = tiers.prenom ? ' ' + tiers.prenom : '';
			return `${nom}${prenom}`;
		} else {
			let libelle = tiers?.formeJuridique ? `${tiers?.formeJuridique + ' ' + tiers?.libelle}` : `${tiers?.libelle}`;
			return `${libelle}`;
		}
	}

	onClose(): void {
		if(this.closeWithUpdate){
			this.action.emit({ type: ActionType.Submit });
		}
		else{
			this.action.emit({ type: ActionType.Close });
		}
	}

	showTiers(tiers?: ITiersWithAdress): void{

		this.modalRef = this.modalService.show(TiersFormComponent, {
			ignoreBackdropClick: true,
			class: 'modal-l'
		});
		
		this.modalRef.content.tiers = tiers;
		this.modalRef.content.libelleKey = this.libelleKey;
		this.modalRef.content.nationalites$ = this.store$.select(SharedStoreSelectors.selectNationalites);
		this.modalRef.content.isToConsult = true;

		this.modalRef.content.action.subscribe(res => {
			if (res.type === ActionType.Close) {	
				this.modalRef.hide();
			}
		});
	}

	onEditTier(tiers: ITiers){
		this.modalRef = this.modalService.show(TiersFormComponent, {
			ignoreBackdropClick: true,
			class: 'modal-l'
		});
		this.modalRef.content.nationalites$ = this.store$.select(SharedStoreSelectors.selectNationalites);
		this.modalRef.content.nationalites$.subscribe(pays => {
			this.modalRef.content.selectedPay = pays?.find(x => x.codeISO == 'FR')?.id;
				});
		
		this.modalRef.content.paysIdField.patchValue(tiers.pays.id);
		this.modalRef.content.tiers = tiers;
		this.modalRef.content.libelleKey = this.libelleKey;
		this.modalRef.content.isToConsult = false;
		this.modalRef.content.isToUpdate = true;
		this.modalRef.content.loader = new StoreLoader(of(false), null);

		this.modalRef.content.action.subscribe(res => {
			if (res.type === ActionType.Close) {
				this.modalRef.hide();
			}
			if (res.type === ActionType.Submit) {
				this.modalRef.content.loader = new StoreLoader(of(true), null);
				this.tiersService.updateTiers({...res.value, id : tiers?.id},	this.affaireId, this.structureId)
				.subscribe(resultUpdate=>{
					this.closeWithUpdate = true;
					this.modalRef.hide();
					this.modalRef.content.loader = new StoreLoader(of(false), null);
					this.tiersPartie = this.tiersPartie.map(tier =>
						tier.id === tiers.id ? 
						{ 
							...tier, 
							...res.value,
							pays : {id : res.value.paysId },
							paysResidenceFiscale : {id : res.value.paysResidenceFiscalId }
							
						}
						 : tier
					  );
				},
				error =>{
					this.modalRef.content.loader = new StoreLoader(of(false), error?.message);
				});
			}
		});
	}
}
